var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',[_c('vue-tags-input',{attrs:{"tags":_vm.tagValue,"autocomplete-items":_vm.autocompleteItems,"add-only-from-autocomplete":true},on:{"tags-changed":_vm.tagsChanged},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }